/**
 * The two static prose callouts on the economic-outlook page: a description
 * shown in the GDP view and a "how to read the plot" box shown in the
 * Inflation view. Pure presentational text — pulled out of the page file so
 * the page reads as layout, not paragraphs.
 */

/** GDP-view description callout, shown above the selectors. */
export function GdpDescriptionCallout(): JSX.Element {
  return (
    <div className="clear-both relative z-0 mt-2 mb-6 rounded-md border-l-4 border-[color:var(--accent)] bg-gray-50 p-4 font-[var(--font-heading)] text-sm leading-relaxed text-gray-600">
      This page presents outputs from Fulcrum&apos;s macroeconomic models. These include nowcasts
      and inflation forecasts for major economies, which serve as core inputs to MARS and provide
      real-time tracking of global activity and price dynamics. The accompanying calendar
      highlights upcoming releases that feed into the estimates, and the chart includes a Click to
      reveal feature showing which data points have driven changes in the nowcast, helping to
      uncover key drivers of activity and inflation.
    </div>
  );
}

/** Inflation-view "how to read the plot" explanation box, shown below the chart. */
export function InflationExplanationBox(): JSX.Element {
  return (
    <div className="clear-both relative z-0 mt-8 mb-10 rounded-md border-l-4 border-[color:var(--accent)] bg-gray-50 p-6">
      <p className="m-0 text-sm leading-relaxed text-gray-600">
        <strong>How to read the plot.</strong> The legend appears at the top of each chart. The
        black line labeled &quot;Historical&quot; shows actual inflation data when available. The
        red line labeled &quot;Forecast&quot; represents current inflation forecasts extending into
        the future. The gray dashed line labeled &quot;One Month Ago Forecast&quot; shows the
        previous month&apos;s forecast for comparison. Blue dots labeled &quot;Central Bank
        Forecast&quot; show official central bank projections when available. The light and dark
        red shaded areas represent the 90% and 68% confidence bands respectively, indicating
        uncertainty around the central forecast. Source: Fulcrum Asset Management. All model
        results are internal estimates and subject to change.
      </p>
    </div>
  );
}
